import api from './api'

export interface EVVLogParams {
  search?: string
  startDate?: string
  endDate?: string
  contractId?: string
  patientId?: string
  therapistId?: string
  page?: number
  limit?: number
}

export interface ContractId {
  _id: string
  contract_ids: string
  patient_id: string
  therapist_id: string
  [key: string]: any
}

export interface EVVLog {
  _id: string
  contract_id: ContractId | string
  session_id: string
  session_ids: string
  patient_id: string
  therapist_id: string
  patient: string
  address: string
  lat: number
  long: number
  clock_in: string
  clock_out?: string
  duration?: number
  is_agree: boolean
  signature?: string
  signed_by_type?: string
  relation?: string
  signed_by_name?: string
  is_deleted: boolean
  createdAt: string
  updatedAt: string
  __v: number
}

export interface EVVLogsResponse {
  evvlog: EVVLog[]
  totalRecords: number
}

export const getEVVLogs = async (
  params: EVVLogParams
): Promise<EVVLogsResponse> => {
  const response = await api.get<EVVLogsResponse>(
    '/sessions/get-evv-log',
    {
      params: {
        search: params.search || '',
        startDate: params.startDate || '',
        endDate: params.endDate || '',
        contractId: params.contractId || '',
        patientId: params.patientId || undefined,
        therapistId: params.therapistId || undefined,
        page: params.page || 1,
        limit: params.limit || 10,
      },
    }
  )

  return response.data
}

export interface ContractDropdownOption {
  _id: string
  contract_ids: string
}

export const getContractDropdowns = async (): Promise<
  ContractDropdownOption[]
> => {
  const response = await api.get<ContractDropdownOption[]>(
    '/contracts/dropdown/contracts'
  )
  return Array.isArray(response.data) ? response.data : []
}

export const exportEVVLogsCSV = async (
  params: Omit<EVVLogParams, 'page' | 'limit'>
): Promise<Blob> => {
  const response = await api.get<Blob>(
    '/sessions/export-evv-log',
    {
      params: {
        search: params.search || '',
        startDate: params.startDate || '',
        endDate: params.endDate || '',
        contractId: params.contractId || '',
        patientId: params.patientId || undefined,
        therapistId: params.therapistId || undefined,
      },
      responseType: 'blob',
    }
  )

  return response.data
}

